import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-white font-sans text-body" data-id="element-0" data-mp="23utb6267bya9">
      <Hero data-id="element-1" data-mp="3ikhaeg9qb525" />
      <main data-id="element-2" data-mp="3iiwdijzxza14">
        <TestimonialsSection variant="strip" data-id="element-3" data-mp="3ij668fcdfvai" />
        <ProblemSection data-id="element-4" data-mp="3mljaezbgzl56" />
        <SolutionSection data-id="element-5" data-mp="3mkrd9k285fcs" />
        <HowItWorksSection data-id="element-6" data-mp="3mk83iqmq9x9u" />
        <VolumesSection data-id="element-7" data-mp="3mjgczu7zmpqf" />
        <BonusesSection data-id="element-8" data-mp="3rcj7c4kla37o" />
        <UrgencySection data-id="element-9" data-mp="3rdapodp6e4g0" />
        <OfferSection data-id="element-10" data-mp="3rcsuzli5vya7" />
        <TestimonialsSection variant="grid" data-id="element-11" data-mp="3relvej26lm9r" />
        <GuaranteeSection data-id="element-12" data-mp="4wvhonpuufq" />
        <FaqSection data-id="element-13" data-mp="56nfhsbnbo2" />
        <FinalCtaSection data-id="element-14" data-mp="7svdij4jt6t" />
      </main>
      <Footer data-id="element-15" data-mp="2zlv6yuqqp1v2" />
      <StickyCta data-id="element-16" data-mp="2zmepodo7rua5" />
    </div>;
}